/* tslint:disable */
/* eslint-disable */
/**
 * AICare API Message
 * CRUD Message
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface DeleteBulkDto
 */
export interface DeleteBulkDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteBulkDto
     */
    'ids': Array<number>;
}
/**
 * 
 * @export
 * @interface MessageDto
 */
export interface MessageDto {
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'status': MessageDtoStatusEnum;
}

export const MessageDtoStatusEnum = {
    Readed: 'READED',
    NoReaded: 'NO_READED'
} as const;

export type MessageDtoStatusEnum = typeof MessageDtoStatusEnum[keyof typeof MessageDtoStatusEnum];

/**
 * 
 * @export
 * @interface MessageFilterTableDto
 */
export interface MessageFilterTableDto {
    /**
     * 
     * @type {string}
     * @memberof MessageFilterTableDto
     */
    'managerId': string;
    /**
     * 
     * @type {string}
     * @memberof MessageFilterTableDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MessageFilterTableDto
     */
    'status'?: MessageFilterTableDtoStatusEnum | null;
}

export const MessageFilterTableDtoStatusEnum = {
    Readed: 'READED',
    NoReaded: 'NO_READED',
    All: 'ALL'
} as const;

export type MessageFilterTableDtoStatusEnum = typeof MessageFilterTableDtoStatusEnum[keyof typeof MessageFilterTableDtoStatusEnum];

/**
 * 
 * @export
 * @interface MessageOrderTableDto
 */
export interface MessageOrderTableDto {
    /**
     * 
     * @type {string}
     * @memberof MessageOrderTableDto
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface MessageRequestTableDto
 */
export interface MessageRequestTableDto {
    /**
     * 
     * @type {number}
     * @memberof MessageRequestTableDto
     */
    'take'?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageRequestTableDto
     */
    'skip'?: number;
    /**
     * 
     * @type {MessageFilterTableDto}
     * @memberof MessageRequestTableDto
     */
    'filter': MessageFilterTableDto | null;
    /**
     * 
     * @type {Array<MessageOrderTableDto>}
     * @memberof MessageRequestTableDto
     */
    'orderBy'?: Array<MessageOrderTableDto> | null;
}
/**
 * 
 * @export
 * @interface MessageResponseTableDto
 */
export interface MessageResponseTableDto {
    /**
     * 
     * @type {number}
     * @memberof MessageResponseTableDto
     */
    'count': number;
    /**
     * 
     * @type {Array<MessageDto>}
     * @memberof MessageResponseTableDto
     */
    'data': Array<MessageDto> | null;
}
/**
 * 
 * @export
 * @interface UpdateMessageDto
 */
export interface UpdateMessageDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    'managerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMessageDto
     */
    'status'?: UpdateMessageDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateMessageDto
     */
    'id': number;
}

export const UpdateMessageDtoStatusEnum = {
    Readed: 'READED',
    NoReaded: 'NO_READED'
} as const;

export type UpdateMessageDtoStatusEnum = typeof UpdateMessageDtoStatusEnum[keyof typeof UpdateMessageDtoStatusEnum];


/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete many Messages
         * @summary Delete many Messages
         * @param {DeleteBulkDto} deleteBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerDelete: async (deleteBulkDto: DeleteBulkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteBulkDto' is not null or undefined
            assertParamExists('messageControllerDelete', 'deleteBulkDto', deleteBulkDto)
            const localVarPath = `/api/v1/message/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBulkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Messages list
         * @summary Get all Messages
         * @param {MessageRequestTableDto} messageRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerFind: async (messageRequestTableDto: MessageRequestTableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageRequestTableDto' is not null or undefined
            assertParamExists('messageControllerFind', 'messageRequestTableDto', messageRequestTableDto)
            const localVarPath = `/api/v1/message/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageRequestTableDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a museum no read
         * @summary Get a message no read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerFindNoRead: async (managerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'managerId' is not null or undefined
            assertParamExists('messageControllerFindNoRead', 'managerId', managerId)
            const localVarPath = `/api/v1/message/{managerId}`
                .replace(`{${"managerId"}}`, encodeURIComponent(String(managerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign as Read
         * @summary Sign as Read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerSignAsRead: async (managerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'managerId' is not null or undefined
            assertParamExists('messageControllerSignAsRead', 'managerId', managerId)
            const localVarPath = `/api/v1/message/noread/{managerId}`
                .replace(`{${"managerId"}}`, encodeURIComponent(String(managerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Message
         * @summary Update Message
         * @param {UpdateMessageDto} updateMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerUpdate: async (updateMessageDto: UpdateMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMessageDto' is not null or undefined
            assertParamExists('messageControllerUpdate', 'updateMessageDto', updateMessageDto)
            const localVarPath = `/api/v1/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete many Messages
         * @summary Delete many Messages
         * @param {DeleteBulkDto} deleteBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageControllerDelete(deleteBulkDto: DeleteBulkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageControllerDelete(deleteBulkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all Messages list
         * @summary Get all Messages
         * @param {MessageRequestTableDto} messageRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageControllerFind(messageRequestTableDto: MessageRequestTableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponseTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageControllerFind(messageRequestTableDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageControllerFind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a museum no read
         * @summary Get a message no read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageControllerFindNoRead(managerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageControllerFindNoRead(managerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageControllerFindNoRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign as Read
         * @summary Sign as Read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageControllerSignAsRead(managerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageControllerSignAsRead(managerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageControllerSignAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Message
         * @summary Update Message
         * @param {UpdateMessageDto} updateMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageControllerUpdate(updateMessageDto: UpdateMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageControllerUpdate(updateMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageApiFp(configuration)
    return {
        /**
         * Delete many Messages
         * @summary Delete many Messages
         * @param {DeleteBulkDto} deleteBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerDelete(deleteBulkDto: DeleteBulkDto, options?: any): AxiosPromise<void> {
            return localVarFp.messageControllerDelete(deleteBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all Messages list
         * @summary Get all Messages
         * @param {MessageRequestTableDto} messageRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerFind(messageRequestTableDto: MessageRequestTableDto, options?: any): AxiosPromise<MessageResponseTableDto> {
            return localVarFp.messageControllerFind(messageRequestTableDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a museum no read
         * @summary Get a message no read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerFindNoRead(managerId: string, options?: any): AxiosPromise<MessageDto> {
            return localVarFp.messageControllerFindNoRead(managerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign as Read
         * @summary Sign as Read
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerSignAsRead(managerId: string, options?: any): AxiosPromise<void> {
            return localVarFp.messageControllerSignAsRead(managerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Message
         * @summary Update Message
         * @param {UpdateMessageDto} updateMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageControllerUpdate(updateMessageDto: UpdateMessageDto, options?: any): AxiosPromise<MessageDto> {
            return localVarFp.messageControllerUpdate(updateMessageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI {
    /**
     * Delete many Messages
     * @summary Delete many Messages
     * @param {DeleteBulkDto} deleteBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageControllerDelete(deleteBulkDto: DeleteBulkDto, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageControllerDelete(deleteBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all Messages list
     * @summary Get all Messages
     * @param {MessageRequestTableDto} messageRequestTableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageControllerFind(messageRequestTableDto: MessageRequestTableDto, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageControllerFind(messageRequestTableDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a museum no read
     * @summary Get a message no read
     * @param {string} managerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageControllerFindNoRead(managerId: string, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageControllerFindNoRead(managerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign as Read
     * @summary Sign as Read
     * @param {string} managerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageControllerSignAsRead(managerId: string, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageControllerSignAsRead(managerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Message
     * @summary Update Message
     * @param {UpdateMessageDto} updateMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageControllerUpdate(updateMessageDto: UpdateMessageDto, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageControllerUpdate(updateMessageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



